/**
 * Adaptive 3 (default 2020) based client theme
 */
export const adaptive3 = {
    name: "adaptive3",
    headingFontWeight: 300,
    headingTextColor: "hsl(186, 76%, 27%)",
    labelFontWeight: 400,
    linkTextColor: "hsl(186, 76%, 27%)",
    defaultTextColor: "#222",
    primary: "hsl(186, 76%, 27%)",
    secondary: "hsl(186, 30%, 48%)",
    secondaryContrast: "#fff",
    tertiary: "hsl(288, 80%, 42%)",
    tertiaryContrast: "#fff",
    success: "#080",
    successContrast: "#fff",
    warning: "#fc0",
    warningContrast: "#542",
    danger: "hsl(0, 100%, 38%)",
    dark: "#222",
    medium: "hsl(200, 12%, 90%)",
    light: "hsl(200, 10%, 98%)",
    buttonPadding: "8px 12px",
    smallButtonPadding: "4px 6px",
    largeButtonPadding: "16px 24px",
    radius: 2,
    buttonStyle: "solid",
    buttonRadius: 2,
    buttonBorderWidth: 0,
    checkboxBorderWidth: 1,
    inputShadowBlur: 0,
    inputShadowOffset: "0 0",
};
